import axios from 'axios'
export default {
  name: 'Inicio',
  components: { },
  data () {
    return {
     errores: []
    }
  },
  created () {
    this.verificarcredenciales()
  },
  methods: {
    verificarcredenciales () {
      if (this.login === true) {
        this.$router.push('/listador')
      } else {
        this.$router.push('/login')
      }
    },
    irregistro () {
      this.$router.push('/login')
    },
    irlistador () {
      this.$router.push('/listador')
    }
  },
  computed: {
    cred: function () {
      return this.$store.getters.credactual
    },
    login () {
      return this.$store.getters.islogin
    }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/inicio.js